import T from 'prop-types'

export const sizePropType = T.oneOf(['small', 'medium', 'large'])
